module.exports = __webpack_public_path__ + "img/pauline-martin.e0e03e93.jpg";